

import { AddCircle, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Autocomplete, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PurpleButton } from '../mui/Buttons';
import { PhoneInput, PurpleSwitch, TextInput } from '../mui/Inputs';
import { DisabledText, GreenText, PrimaryText, PurpleText, SecondaryText } from '../mui/Typography';
import PassInfoRow from './PassInfoRow';
import '../../styling/editListing.css'
import axios from "axios";
import { auth } from '../..';




export default function GeneralInfoEL({gym,refreshP}) {

    const getCurrency = () => {
        var curr = 'EUR'

        if(gym.country === "Hungary"){curr = 'HUF'}
        if(gym.country === "Scotland" || gym.country === "England" || gym.country === "Northern Ireland"){curr = 'GBP'}
        if(gym.country === "Czechia" || gym.country === "Czech Republic"){curr = 'Kč'}
        if(gym.country === "Canada"){curr = 'CAD'}
        if(gym.country === "USA"){curr = 'USD'}
        if(gym.country === "Australia"){curr = 'AUD'}
        if(gym.country === "Switzerland"){curr = 'CHF'}

        return curr
    }


    const baseURL = "https://us-central1-travel-fitness-pass.cloudfunctions.net/";

    const [open1,setOpen1] = useState(true)

    
    const [businessName,setBusinessName] = useState(gym!==null?gym.name:"")
    const [address,setAddress] = useState(gym!==null?gym.address:"")
    const [city,setCity] = useState(gym!==null?gym.city:"")
    const [country,setCountry] = useState(gym!==null?gym.country:"")

    const [contactName,setContactName] = useState(gym!==null?gym.contactName:"")
    const [contactEmail,setContactEmail] = useState(gym!==null?gym.contactEmail:"")
    const [contactPhone,setContactPhone] = useState(gym!==null?gym.contactPhone:"")

    const countryOptions = [ "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Åland Islands" ];
    
    const [sellPasses,setSellPasses] = useState(gym.sellsPasses)
    const [hasStripeAccount,setHasStripe] = useState(false)

    const [passRows,setPassRows] = useState(gym!==null?gym.passes:[{id:Math.random().toString(16).slice(2),name:"",days:"",price:"",curreny:"EUR"}])
    const [currency,setCurrency] = useState(getCurrency())
    const [showCurrencyText,setShowCurrencyText] = useState(false)

    const [updateVar,setUpdateVar] = useState(0)

    const [buttonDisabled,setButtonDisabled] = useState(false)


    const [currentlyUpdating,setCurrentlyUpdating] = useState(false)
    const [updatedSuccess,setUpdatedSuccess] = useState(false)

    const [showRefreshButton,setShowRefresh] = useState(false)

    const [uid,setUID] = useState(auth.currentUser.uid)

    
    useEffect(() => {
        
        let disabled = disableButton()
        setButtonDisabled(disabled)
        
      }, [businessName,address,city,country,contactName,contactPhone,contactEmail,updateVar,sellPasses]);



    const showPassRows = () => {
        let passAray = []
        var index = 0


        passRows.forEach(row => {
            let passRow = 
                <PassInfoRow 
                    index={index} 
                    nameP={row.name} 
                    daysP={row.days} 
                    priceP={row.price}
                    currencyP={currency}
                    currencyChanged={currencyChanged}
                    edit={editPassRow}
                    deleteFunc={deletePassRow}
                />
            passAray.push(passRow)
            index++
        });

        return passAray
    }

    const addPassRow = () => {
        passRows.push({id:Math.random().toString(16).slice(2),name:"",days:1,price:""})
        setPassRows(passRows)
        setUpdateVar(updateVar+1)
    }

    const editPassRow = (index,value) => {
        passRows[index] = value
        setPassRows(passRows)
        setUpdateVar(updateVar+1)
        console.log("EPR",passRows)
    }

    const deletePassRow = (index) => {
        passRows.splice(index, 1)
        setPassRows(passRows)
        setUpdateVar(updateVar+1)
    }

    const checkFields = () => {
        let uid = auth.currentUser.uid
         updatetDB(uid)
    }

    const currencyChanged = (currencyP) => {
        setCurrency(currencyP)
        if(currencyP!=="EUR"){setShowCurrencyText(true)}
    }



    
    const disableButton = () => {


        console.log("Sells  passes", sellPasses)

        if(businessName.length === 0){return true}
        else if(address.length === 0){return true}
        else if(city.length === 0){return true}
        else if(country.length === 0){return true}
        else if(sellPasses === null && !uid.includes('LriAMmPV7')){return true}

        // else if(contactName.length === 0){return true}
        // else if(contactPhone.length === 0){return true}
        // else if(contactEmail.length === 0){return true}

        else{
            return false
        }
    }

    
    const updatetDB = (uid) => {
        
        let gymID = gym.id

        setUpdatedSuccess(false)
        setCurrentlyUpdating(true)

        axios.post(baseURL+'editListingGeneralInfo',{
        
            uid:uid,
            gymID:gymID,
            businessName:businessName,
            address:address,
            city:city,
            country:country,

            contactName:contactName,
            contactEmail:contactEmail,
            contactPhone:contactPhone,

            currency:currency,
            passes:passRows,
            sellPasses:sellPasses

        
        }).then((response) => {
            let resVar = response.data
            console.log("Response", resVar)

            setUpdatedSuccess(true)
            setCurrentlyUpdating(false)
        })
    }

    const loadStripeConnect = () => {
        setShowRefresh(true)
        window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_LuxPslvbayGHdwP6AeTwmPzpydTs3VFO&state='+gym.id)
        //TEST window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_LuxPUJCocHPg6yJMFhjmkRqQnXPtqitO&state='+gym.id);
    }

    const refresh = () => {
        refreshP(gym.id)
    }



    return(

        <Accordion className='accordionEL' TransitionProps={{ unmountOnExit: true }} expanded={open1}>
                            <AccordionSummary onClick={()=>setOpen1(!open1)}>
                                <div className='portalEditBlockTop'>
                                    <div>
                                        <PrimaryText variant='h4'>General Info</PrimaryText>
                                        {open1 && <SecondaryText variant='subtitle2'>Help users know where to find you</SecondaryText>}
                                    </div>
                                    
                                    {open1 && <ExpandLess />}
                                    {!open1 && <ExpandMore />}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                
                                <div className='portalEditSec1Content'>
                                    <div className='portalEditRow'>

                                    
                                        <div className='portalEditColumn'>
                                        
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Basic Info</SecondaryText>
                                                <SecondaryText variant='subtitle2'>Help users know where to find you</SecondaryText>
                                            </div>
                                            
                                            <TextInput className='portalEditInput' variant="outlined" label="Business Name"
                                                value={businessName} onChange={(e) => setBusinessName(e.target.value)}/>
                                            
                                            <TextInput className='portalEditInput' variant="outlined" label="Address"
                                                value={address} onChange={(e) => setAddress(e.target.value)}/>

                                            <TextInput className='portalEditInput' variant="outlined" label="City"
                                                value={city} onChange={(e) => setCity(e.target.value)}/>

                                            <Autocomplete className='portalEditCountry' disablePortal defaultValue={country} options={countryOptions} renderInput={(params)=><TextInput {...params} variant="outlined" label="Country" value={"Angola"} />} onChange={(e) => setCountry(e.target.textContent)}/>

                                            
                                        </div>
                                        <div className='portalEditColumn'>
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Contact Information</SecondaryText>
                                                <SecondaryText variant='subtitle2'>This will NOT appear on your profile</SecondaryText>
                                            </div>

                                            <TextInput className='portalEditInput' variant="outlined" label="Contact Name"
                                                value={contactName} onChange={(e) => setContactName(e.target.value)}/>

                                            <TextInput className='portalEditInput' variant="outlined" label="Contact Email"
                                                value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}/>

                                            <PhoneInput className='portalEditInput' defaultCountry={'ie'} variant="outlined" label="Phone number"
                                                value ={contactPhone} onChange={(e) => setContactPhone(e)}/>

                                        </div>

                                     </div>

                                     <div className='portalEditColumn passRowSection'>
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Pass Information</SecondaryText>
                                                <SecondaryText variant='subtitle2'>{`What short term passes do you offer for visitors? ${showCurrencyText?"(Users will see coverted price in their selected currency) ":""}`}</SecondaryText>
                                                
                                            </div>
                                            

                                            {showPassRows()}
                                            
                                            <div className={`addPassRow`} onClick={addPassRow}>
                                            <div className={`addPassRowContent`}>
                                                <AddCircle />
                                                <PrimaryText variant="body1">Add Pass Option</PrimaryText>
                                                </div>
                                            </div>

                                            <div className='portalEditSubtitles'>
                                                
                                            <PrimaryText variant='subtitle2'>Would you like to sell your passes directly on the platform?</PrimaryText>
                                                
                                                {/* <div className='wcAccessSwitchRow'>
                                                    
                                                    {hasStripeAccount && <PrimaryText variant='body1'>No</PrimaryText>}
                                                    {!hasStripeAccount && <DisabledText variant='body1'>No</DisabledText>}
                                                    <PurpleSwitch checked={sellPasses} onChange={(e)=>setSellPasses(e.target.checked)} disabled={!hasStripeAccount}/>
                                                    {hasStripeAccount && <PrimaryText variant='body1'>Yes</PrimaryText>}
                                                    {!hasStripeAccount && <DisabledText variant='body1'>Yes</DisabledText>}
                                                    
                                                </div>     */}

                                                <div className='sellPassesRadios'>
                                                <FormControl>

                                                    <RadioGroup
                                                        row
                                                        name="row-radio-buttons-group"
                                                        value={sellPasses}
                                                        onChange={(e)=>setSellPasses(e.target.value === "true")}
                                                    >
                                                        <FormControlLabel value={false} control={<Radio />} label="No" />
                                                        <FormControlLabel
                                                        value={true}
                                                        // disabled = {!hasStripeAccount}
                                                        control={<Radio />}
                                                        label="Yes"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                                </div>

                                                {!hasStripeAccount && <div className='sellsPassesRow'>
                                                    <SecondaryText variant='body2'>You have no linked payment to your account.</SecondaryText>
                                                    <PurpleText className='sellPassesLink' variant='subtitle2' onClick={loadStripeConnect}>Sign up to sell passes</PurpleText>       
                                                        
                                                </div>}

                                                
                                                
                                                
                                            </div>
                                            

                                        </div>

                                </div>

                                
                            </AccordionDetails>

                            <AccordionActions>
                                {currentlyUpdating && <PurpleText variant='body2' className='updatedSuccessfully'>Updating...</PurpleText>}
                                {updatedSuccess && <GreenText variant='body2' className='updatedSuccessfully'>Data updated successfully</GreenText>}
                                {(!sellPasses||hasStripeAccount)&&<PurpleButton size='large' variant='contained' disabled={buttonDisabled || currentlyUpdating} onClick={checkFields}>SAVE</PurpleButton>}
                        
                                {((sellPasses&&!hasStripeAccount)&&!showRefreshButton)&&<PurpleButton size='large' variant='contained' onClick={loadStripeConnect}>Sign up to sell passes</PurpleButton>}
                                {(showRefreshButton&&!hasStripeAccount&&sellPasses)&&<PurpleButton size='large' variant='contained' onClick={refresh}>Refresh</PurpleButton>}

                            </AccordionActions>

                        </Accordion>
    )
}